
//普通下载
export function downloadByUrl(url: string, name: string) {
  const a = document.createElement('a');
  a.href = url
  a.download = name
  document.body.appendChild(a);
  a.click()
  document.body.removeChild(a);
  window.URL.revokeObjectURL(a.href);
}

//自定义文件名下载
export function downloadByUrlWithFileName(item: any) {
  let fileName = item.fileName
  if (item?.fileName?.includes("/")) {
    const arr = item.fileName.split("/")
    if (arr?.length > 0) {
      fileName = arr.pop()
    }
  }
  const xml = new XMLHttpRequest();
  xml.open('GET', item.fileUrl, true);
  xml.responseType = 'blob';
  xml.onload = function () {
      const url = window.URL.createObjectURL(xml.response);
      const a = document.createElement('a');
      a.href = url;
      a.download = fileName;
      a.click();
  };
  xml.send();
  
}